import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { createTheme } from '.'

export const ThemeInitializer = ({ children }) => {
  const { theme } = useSelector((state) => state.partnerDetails)

  const muiTheme = useMemo(() => {
    return createTheme({
      colorPreset: theme?.colors,
      contrast: 'high',
      themeLogo: theme?.logo,
      companyName: theme?.companyName
    })
  }, [theme?.colors, theme?.logo, theme?.companyName])

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
